import { EmailSetup } from './../Model/EmailSetup';
import { TRP_COMPANY_SETUP } from './../Model/TRP_COMPANY_SETUP';
import { TrpPaidTopaycharge } from './../Model/TrpPaidTopaycharge';
import { GreentaxSlab } from './../Model/GreentaxSlab';

import { Trpcharges } from './../Model/Trpcharges';
import { EmployeeMaster } from './../Model/EmployeeMaster';
import { DriverMaster } from './../Model/DriverMaster';
import { LocationMaster } from '../Model/LocationMaster';
import { PartySuppliers } from '../Model/PartySuppliers';
import { environment } from '../../environments/environment';
import { Injectable, Input } from '@angular/core';
import { Observable } from 'rxjs';
import { HttpHeaders, HttpClient } from '@angular/common/http';
import { PartyMaster } from '../Model/PartyMaster';
import { ACCVEHTYPES } from '../Model/ACCVEHTYPES';
import { VehicleMaster } from '../Model/VehicleMaster';
import { BrokerMaster } from '../Model/BrokerMaster';
import { Trpaccpartno } from '../Model/Trpaccpartno';
import { Trptvcharges } from '../Model/Trpvtcharges';
import { UserMaster } from '../Model/UserMaster';
import { VenderMaster } from '../Model/VenderMaster';
import { DesignationRoleMaster } from '../Model/DesignationRoleMaster';
import { RoleMaster } from '../Model/RoleMaster';
import { Greentaxftl } from '../Model/Greentaxftl';
import { Events } from '../Model/Events';
import { PartyUser } from '../Model/PartyUser';

@Injectable({
  providedIn: 'root'
})
export class MasterConfigrationService {

  constructor (private _httpClient: HttpClient) { }

  GETPartyList(iType: number, searchvalue: string): Observable<any> {
    searchvalue = btoa(searchvalue);
    let headers = new HttpHeaders();
    headers = headers.append("Authorization", "Bearer " + environment.token);
    headers = headers.append("Content-Type", "application/json");
    const httpOptions = { headers };
    // let body = JSON.stringify(input);
    return this._httpClient.get(environment.WebserviceUrl + "partymaster?iType=" + iType + "&searchvalue=" + searchvalue, httpOptions);
  }

  GETPENDINGPARTYFORCHARGEADD(intype: number, cnmode: number, floc: number, tloc: number): Observable<any> {
    let headers = new HttpHeaders();
    headers = headers.append("Authorization", "Bearer " + environment.token);
    headers = headers.append("Content-Type", "application/json");
    const httpOptions = { headers };
    // let body = JSON.stringify(input);
    return this._httpClient.get(environment.WebserviceUrl + "partymaster?intype=" + intype + "&cnmode=" + cnmode + "&floc=" + floc + "&tloc=" + tloc, httpOptions);
  }

  GetPartyForDDL(intype: number, locid: number, accode: string): Observable<any> {
    let headers = new HttpHeaders();
    headers = headers.append("Authorization", "Bearer " + environment.token);
    headers = headers.append("Content-Type", "application/json");
    const httpOptions = { headers };
    return this._httpClient.get(environment.WebserviceUrl + "partymaster?intype=" + intype + "&locid=" + locid + "&accode=" + accode, httpOptions);
  }


  GetPartyForByACC_CSTNO(ACC_CSTNO: string): Observable<any> {
    let headers = new HttpHeaders();
    headers = headers.append("Authorization", "Bearer " + environment.token);
    headers = headers.append("Content-Type", "application/json");
    const httpOptions = { headers };
    return this._httpClient.get(environment.WebserviceUrl + "PartyMasterHelper?CSTNO=" + ACC_CSTNO, httpOptions);
  }

  GETVehicleTypeList(): Observable<any> {
    let headers = new HttpHeaders();
    headers = headers.append("Authorization", "Bearer " + environment.token);
    headers = headers.append("Content-Type", "application/json");
    const httpOptions = { headers };
    // let body = JSON.stringify(input);
    return this._httpClient.get(environment.WebserviceUrl + "VehicleType", httpOptions);
  }

  GETMaxPartyCode(): Observable<any> {
    let headers = new HttpHeaders();
    headers = headers.append("Authorization", "Bearer " + environment.token);
    headers = headers.append("Content-Type", "application/json");
    const httpOptions = { headers };
    // let body = JSON.stringify(input);
    return this._httpClient.get(environment.WebserviceUrl + "GetMaxPartyCode", httpOptions);
  }

  AddNewParty(input: PartyMaster): Observable<any> {
    let headers = new HttpHeaders();
    headers = headers.append("Authorization", "Bearer " + environment.token);
    headers = headers.append("Content-Type", "application/json");
    const httpOptions = { headers };
    let body = JSON.stringify(input);
    return this._httpClient.post(environment.WebserviceUrl + "partymaster", body, httpOptions);
  }

  DeleteParty(id: string, iUserId: number, iActive: number): Observable<any> {
    let headers = new HttpHeaders();
    headers = headers.append("Authorization", "Bearer " + environment.token);
    headers = headers.append("Content-Type", "application/json");
    const httpOptions = { headers };
    return this._httpClient.delete(environment.WebserviceUrl + "partymaster?id=" + id + "&iUserId=" + iUserId + "&iActive=" + iActive, httpOptions);
  }

  UpdateVehicleType(input: ACCVEHTYPES[]): Observable<any> {
    let headers = new HttpHeaders();
    headers = headers.append("Authorization", "Bearer " + environment.token);
    headers = headers.append("Content-Type", "application/json");
    const httpOptions = { headers };
    let body = JSON.stringify(input);
    return this._httpClient.post(environment.WebserviceUrl + "VehicleType", body, httpOptions);
  }

  GetSinglePartyRecord(input: string): Observable<any> {
    let headers = new HttpHeaders();
    headers = headers.append("Authorization", "Bearer " + environment.token);
    headers = headers.append("Content-Type", "application/json");
    const httpOptions = { headers };
    return this._httpClient.get(environment.WebserviceUrl + 'partymaster/' + input, httpOptions);
  }

  UpdateParty(input: PartyMaster): Observable<any> {
    let headers = new HttpHeaders();
    // headers = headers.append("Access-Control-Allow-Origin", "*");
    // headers = headers.append("Access-Control-Allow-Methods", "GET,HEAD,OPTIONS,POST,PUT");
    // headers = headers.append("Access-Control-Allow-Headers", "Origin, X-Requested-With, Content-Type,Accept, x-client-key, x-client-token, x-client-secret, Authorization");
    headers = headers.append("Authorization", "Bearer " + environment.token);
    headers = headers.append("Content-Type", "application/json");
    const httpOptions = { headers };
    let body = JSON.stringify(input);
    //console.log(body);
    return this._httpClient.put(environment.WebserviceUrl + "partymaster", body, httpOptions);
  }

  GETPackingTypeList(): Observable<any> {
    let headers = new HttpHeaders();
    headers = headers.append("Authorization", "Bearer " + environment.token);
    headers = headers.append("Content-Type", "application/json");
    const httpOptions = { headers };
    // let body = JSON.stringify(input);
    return this._httpClient.get(environment.WebserviceUrl + "Packing", httpOptions);
  }

  AddPartySuppliers(input: PartySuppliers): Observable<any> {
    let headers = new HttpHeaders();
    headers = headers.append("Authorization", "Bearer " + environment.token);
    headers = headers.append("Content-Type", "application/json");
    const httpOptions = { headers };
    let body = JSON.stringify(input);
    return this._httpClient.post(environment.WebserviceUrl + "PartySuppliers", body, httpOptions);
  }

  UpdatePartySuppliers(input: PartySuppliers): Observable<any> {
    let headers = new HttpHeaders();
    headers = headers.append("Authorization", "Bearer " + environment.token);
    headers = headers.append("Content-Type", "application/json");
    const httpOptions = { headers };
    let body = JSON.stringify(input);
    return this._httpClient.put(environment.WebserviceUrl + "PartySuppliers", body, httpOptions);
  }

  GETPartySuppliers(input: string): Observable<any> {
    let headers = new HttpHeaders();
    headers = headers.append("Authorization", "Bearer " + environment.token);
    headers = headers.append("Content-Type", "application/json");
    const httpOptions = { headers };
    return this._httpClient.get(environment.WebserviceUrl + "PartySuppliers/" + input, httpOptions);
  }

  GetSingleSupplierDetail(crcode: number, cncode: number): Observable<any> {
    let headers = new HttpHeaders();
    headers = headers.append("Authorization", "Bearer " + environment.token);
    headers = headers.append("Content-Type", "application/json");
    const httpOptions = { headers };
    return this._httpClient.get(environment.WebserviceUrl + "PartySuppliers?crcode=" + crcode + "&cncode=" + cncode, httpOptions);
  }


  DeletePartySupplier(CN_CRCODE: number, CN_CNCODE: number): Observable<any> {
    let headers = new HttpHeaders();
    headers = headers.append("Authorization", "Bearer " + environment.token);
    headers = headers.append("Content-Type", "application/json");
    const httpOptions = { headers };
    return this._httpClient.delete(environment.WebserviceUrl + "PartySuppliers?CN_CRCODE=" + CN_CRCODE + "&CN_CNCODE=" + CN_CNCODE, httpOptions);
  }

  //Get Branch Master
  GetBranchMaster(): Observable<any> {
    let headers = new HttpHeaders();
    headers = headers.append("Authorization", "Bearer " + environment.token);
    headers = headers.append("Content-Type", "application/json");
    const httpOptions = { headers };
    return this._httpClient.get(environment.WebserviceUrl + "LocationMaster", httpOptions);
  }

  AddLocationMaster(input: LocationMaster): Observable<any> {
    let headers = new HttpHeaders();
    headers = headers.append("Authorization", "Bearer " + environment.token);
    headers = headers.append("Content-Type", "application/json");
    const httpOptions = { headers };
    let body = JSON.stringify(input);
    return this._httpClient.post(environment.WebserviceUrl + "LocationMaster", body, httpOptions);
  }

  UPDATELocationMaster(input: LocationMaster): Observable<any> {
    let headers = new HttpHeaders();
    headers = headers.append("Authorization", "Bearer " + environment.token);
    headers = headers.append("Content-Type", "application/json");
    const httpOptions = { headers };
    let body = JSON.stringify(input);
    return this._httpClient.put(environment.WebserviceUrl + "LocationMaster", body, httpOptions);
  }

  GetLocationById(input: number): Observable<any> {
    let headers = new HttpHeaders();
    headers = headers.append("Authorization", "Bearer " + environment.token);
    headers = headers.append("Content-Type", "application/json");
    const httpOptions = { headers };
    return this._httpClient.get(environment.WebserviceUrl + "LocationMaster?id=0&locid=" + input, httpOptions);
  }

  //Vehicle Master

  GetVehicleList(): Observable<any> {
    let headers = new HttpHeaders();
    headers = headers.append("Authorization", "Bearer " + environment.token);
    headers = headers.append("Content-Type", "application/json");
    const httpOptions = { headers };
    return this._httpClient.get(environment.WebserviceUrl + "vehiclemaster", httpOptions);
  }

  GetVehicleListForTruckArrival(iType: number, floc: number, tloc: number): Observable<any> {
    let headers = new HttpHeaders();
    headers = headers.append("Authorization", "Bearer " + environment.token);
    headers = headers.append("Content-Type", "application/json");
    const httpOptions = { headers };
    return this._httpClient.get(environment.WebserviceUrl + "vehiclemaster?iType=" + iType + "&floc=" + floc + "&tloc=" + tloc, httpOptions);
  }

  AddNewVehicle(input: VehicleMaster): Observable<any> {
    let headers = new HttpHeaders();
    headers = headers.append("Authorization", "Bearer " + environment.token);
    headers = headers.append("Content-Type", "application/json");
    const httpOptions = { headers };
    let body = JSON.stringify(input);
    return this._httpClient.post(environment.WebserviceUrl + "vehiclemaster", body, httpOptions);
  }

  GetVehicleByNo(input: string): Observable<any> {
    let headers = new HttpHeaders();
    headers = headers.append("Authorization", "Bearer " + environment.token);
    headers = headers.append("Content-Type", "application/json");
    const httpOptions = { headers };
    return this._httpClient.get(environment.WebserviceUrl + 'vehiclemaster/' + input.toString(), httpOptions);
  }

  UpdateVehicle(input: VehicleMaster): Observable<any> {
    let headers = new HttpHeaders();
    headers = headers.append("Authorization", "Bearer " + environment.token);
    headers = headers.append("Content-Type", "application/json");
    const httpOptions = { headers };
    let body = JSON.stringify(input);
    return this._httpClient.put(environment.WebserviceUrl + "vehiclemaster", body, httpOptions);
  }

  DeleteVehicle(vhno: string): Observable<any> {
    let headers = new HttpHeaders();
    headers = headers.append("Authorization", "Bearer " + environment.token);
    headers = headers.append("Content-Type", "application/json");
    const httpOptions = { headers };
    return this._httpClient.delete(environment.WebserviceUrl + "vehiclemaster/" + vhno, httpOptions);
  }
  //End

  //Driver Master

  GetDriverList(): Observable<any> {
    let headers = new HttpHeaders();
    headers = headers.append("Authorization", "Bearer " + environment.token);
    headers = headers.append("Content-Type", "application/json");
    const httpOptions = { headers };
    return this._httpClient.get(environment.WebserviceUrl + "drivermaster", httpOptions);
  }

  AddNewDriver(input: DriverMaster): Observable<any> {
    let headers = new HttpHeaders();
    headers = headers.append("Authorization", "Bearer " + environment.token);
    headers = headers.append("Content-Type", "application/json");
    const httpOptions = { headers };
    let body = JSON.stringify(input);
    return this._httpClient.post(environment.WebserviceUrl + "drivermaster", body, httpOptions);
  }

  GetDriverById(input: string): Observable<any> {
    let headers = new HttpHeaders();
    headers = headers.append("Authorization", "Bearer " + environment.token);
    headers = headers.append("Content-Type", "application/json");
    const httpOptions = { headers };
    return this._httpClient.get(environment.WebserviceUrl + 'drivermaster/' + input.toString(), httpOptions);
  }

  UpdateDriver(input: DriverMaster): Observable<any> {
    let headers = new HttpHeaders();
    headers = headers.append("Authorization", "Bearer " + environment.token);
    headers = headers.append("Content-Type", "application/json");
    const httpOptions = { headers };
    let body = JSON.stringify(input);
    return this._httpClient.put(environment.WebserviceUrl + "drivermaster", body, httpOptions);
  }

  DeleteDriver(vhno: string): Observable<any> {
    let headers = new HttpHeaders();
    headers = headers.append("Authorization", "Bearer " + environment.token);
    headers = headers.append("Content-Type", "application/json");
    const httpOptions = { headers };
    return this._httpClient.delete(environment.WebserviceUrl + "drivermaster?id=" + vhno, httpOptions);
  }
  //End

  //Broker Master

  GetBrokerList(): Observable<any> {
    let headers = new HttpHeaders();
    headers = headers.append("Authorization", "Bearer " + environment.token);
    headers = headers.append("Content-Type", "application/json");
    const httpOptions = { headers };
    return this._httpClient.get(environment.WebserviceUrl + "BrokerMaster", httpOptions);
  }

  AddNewBroker(input: BrokerMaster): Observable<any> {
    let headers = new HttpHeaders();
    headers = headers.append("Authorization", "Bearer " + environment.token);
    headers = headers.append("Content-Type", "application/json");
    const httpOptions = { headers };
    let body = JSON.stringify(input);
    return this._httpClient.post(environment.WebserviceUrl + "BrokerMaster", body, httpOptions);
  }

  GetBrokerById(input: string): Observable<any> {
    let headers = new HttpHeaders();
    headers = headers.append("Authorization", "Bearer " + environment.token);
    headers = headers.append("Content-Type", "application/json");
    const httpOptions = { headers };
    return this._httpClient.get(environment.WebserviceUrl + 'BrokerMaster/' + input.toString(), httpOptions);
  }

  UpdateBroker(input: BrokerMaster): Observable<any> {
    let headers = new HttpHeaders();
    headers = headers.append("Authorization", "Bearer " + environment.token);
    headers = headers.append("Content-Type", "application/json");
    const httpOptions = { headers };
    let body = JSON.stringify(input);
    return this._httpClient.put(environment.WebserviceUrl + "BrokerMaster", body, httpOptions);
  }

  DeleteBroker(vhno: string): Observable<any> {
    let headers = new HttpHeaders();
    headers = headers.append("Authorization", "Bearer " + environment.token);
    headers = headers.append("Content-Type", "application/json");
    const httpOptions = { headers };
    return this._httpClient.delete(environment.WebserviceUrl + "BrokerMaster?id=" + vhno, httpOptions);
  }

  GetBrokerByLocId(inputloc: number): Observable<any> {
    let headers = new HttpHeaders();
    headers = headers.append("Authorization", "Bearer " + environment.token);
    headers = headers.append("Content-Type", "application/json");
    const httpOptions = { headers };
    return this._httpClient.get(environment.WebserviceUrl + 'brokerhelper/' + inputloc.toString(), httpOptions);
  }
  //End

  //Employee Master
  GetEmployeeByLocation(input: number): Observable<any> {
    let headers = new HttpHeaders();
    headers = headers.append("Authorization", "Bearer " + environment.token);
    headers = headers.append("Content-Type", "application/json");
    const httpOptions = { headers };
    return this._httpClient.get(environment.WebserviceUrl + 'employeehelper/' + input.toString(), httpOptions);
  }

  GetEmployeeList(): Observable<any> {
    let headers = new HttpHeaders();
    headers = headers.append("Authorization", "Bearer " + environment.token);
    headers = headers.append("Content-Type", "application/json");
    const httpOptions = { headers };
    return this._httpClient.get(environment.WebserviceUrl + "employee", httpOptions);
  }

  AddEmployee(input: EmployeeMaster): Observable<any> {
    let headers = new HttpHeaders();
    headers = headers.append("Authorization", "Bearer " + environment.token);
    headers = headers.append("Content-Type", "application/json");
    const httpOptions = { headers };
    let body = JSON.stringify(input);
    return this._httpClient.post(environment.WebserviceUrl + "employee", body, httpOptions);
  }

  GetEmployeeById(input: string): Observable<any> {
    let headers = new HttpHeaders();
    headers = headers.append("Authorization", "Bearer " + environment.token);
    headers = headers.append("Content-Type", "application/json");
    const httpOptions = { headers };
    return this._httpClient.get(environment.WebserviceUrl + 'employee/' + input.toString(), httpOptions);
  }

  UpdateEmployee(input: EmployeeMaster): Observable<any> {
    let headers = new HttpHeaders();
    headers = headers.append("Authorization", "Bearer " + environment.token);
    headers = headers.append("Content-Type", "application/json");
    const httpOptions = { headers };
    let body = JSON.stringify(input);
    return this._httpClient.put(environment.WebserviceUrl + "employee", body, httpOptions);
  }

  DeleteEmployee(vhno: string): Observable<any> {
    let headers = new HttpHeaders();
    headers = headers.append("Authorization", "Bearer " + environment.token);
    headers = headers.append("Content-Type", "application/json");
    const httpOptions = { headers };
    return this._httpClient.delete(environment.WebserviceUrl + "employee?id=" + vhno, httpOptions);
  }
  //End

  //Department and designation
  GetDepartmetList(): Observable<any> {
    let headers = new HttpHeaders();
    headers = headers.append("Authorization", "Bearer " + environment.token);
    headers = headers.append("Content-Type", "application/json");
    const httpOptions = { headers };
    return this._httpClient.get(environment.WebserviceUrl + "Department", httpOptions);
  }

  GetDesignationList(): Observable<any> {
    let headers = new HttpHeaders();
    headers = headers.append("Authorization", "Bearer " + environment.token);
    headers = headers.append("Content-Type", "application/json");
    const httpOptions = { headers };
    return this._httpClient.get(environment.WebserviceUrl + "Designation", httpOptions);
  }
  //End

  //BrancCity
  GetBrancCityList(id: number): Observable<any> {
    let headers = new HttpHeaders();
    headers = headers.append("Authorization", "Bearer " + environment.token);
    headers = headers.append("Content-Type", "application/json");
    const httpOptions = { headers };
    return this._httpClient.get(environment.WebserviceUrl + "Branchcity/" + id, httpOptions);
  }

  UpdateBranchCity(input: any[]): Observable<any> {
    let headers = new HttpHeaders();
    headers = headers.append("Authorization", "Bearer " + environment.token);
    headers = headers.append("Content-Type", "application/json");
    const httpOptions = { headers };
    let body = JSON.stringify(input);
    return this._httpClient.post(environment.WebserviceUrl + "Branchcity", body, httpOptions);
  }
  //End

  //Charge Master
  AddChargeDetail(input: Trpcharges): Observable<any> {
    let headers = new HttpHeaders();
    headers = headers.append("Authorization", "Bearer " + environment.token);
    headers = headers.append("Content-Type", "application/json");
    const httpOptions = { headers };
    let body = JSON.stringify(input);
    return this._httpClient.post(environment.WebserviceUrl + "Chargemaster", body, httpOptions);
  }

  GetCharges(input: string): Observable<any> {
    let headers = new HttpHeaders();
    headers = headers.append("Authorization", "Bearer " + environment.token);
    headers = headers.append("Content-Type", "application/json");
    const httpOptions = { headers };
    return this._httpClient.get(environment.WebserviceUrl + 'Chargemaster/' + input, httpOptions);
  }

  GetChargesForGRBooking(acccode: string, floc: number, toloc: number, cnmode: number): Observable<any> {
    let headers = new HttpHeaders();
    headers = headers.append("Authorization", "Bearer " + environment.token);
    headers = headers.append("Content-Type", "application/json");
    const httpOptions = { headers };
    return this._httpClient.get(environment.WebserviceUrl + "Chargemaster?acccode=" + acccode + "&floc=" + floc + "&toloc=" + toloc + "&cnmode=" + cnmode, httpOptions);
  }


  DeleteCharge(acccode: string, cnmode: number, floc: number, tloc: number): Observable<any> {
    let headers = new HttpHeaders();
    headers = headers.append("Authorization", "Bearer " + environment.token);
    headers = headers.append("Content-Type", "application/json");
    const httpOptions = { headers };
    return this._httpClient.delete(environment.WebserviceUrl + "Chargemaster?acccode=" + acccode + "&cnmode=" + cnmode + "&floc=" + floc + "&tloc=" + tloc, httpOptions);
  }

  //--------------------------------------------Full Load Charge-------------------------------------------------
  AddFullLoadChargeDetail(input: Trptvcharges): Observable<any> {
    let headers = new HttpHeaders();
    headers = headers.append("Authorization", "Bearer " + environment.token);
    headers = headers.append("Content-Type", "application/json");
    const httpOptions = { headers };
    let body = JSON.stringify(input);
    return this._httpClient.post(environment.WebserviceUrl + "FullLoadCharge", body, httpOptions);
  }

  GetFullLoadCharges(input: string): Observable<any> {
    let headers = new HttpHeaders();
    headers = headers.append("Authorization", "Bearer " + environment.token);
    headers = headers.append("Content-Type", "application/json");
    const httpOptions = { headers };
    return this._httpClient.get(environment.WebserviceUrl + 'FullLoadCharge/' + input, httpOptions);
  }

  GetFullLoadChargeForGR(acccode: string, vehtype: string, floc: number, tloc: number): Observable<any> {
    let headers = new HttpHeaders();
    headers = headers.append("Authorization", "Bearer " + environment.token);
    headers = headers.append("Content-Type", "application/json");
    const httpOptions = { headers };
    return this._httpClient.get(environment.WebserviceUrl + "FullLoadCharge?acccode=" + acccode + "&vehtype=" + vehtype + "&floc=" + floc + "&tloc=" + tloc, httpOptions);
  }


  DeleteFullLoadCharge(acccode: string, vehtype: string, floc: number, tloc: number): Observable<any> {
    let headers = new HttpHeaders();
    headers = headers.append("Authorization", "Bearer " + environment.token);
    headers = headers.append("Content-Type", "application/json");
    const httpOptions = { headers };
    return this._httpClient.delete(environment.WebserviceUrl + "FullLoadCharge?acccode=" + acccode + "&vehtype=" + vehtype + "&floc=" + floc + "&tloc=" + tloc, httpOptions);
  }

  //-------------------------------------------------------------------Part NO charge--------------------------------------------------

  AddPartNoDetail(input: Trpaccpartno): Observable<any> {
    let headers = new HttpHeaders();
    headers = headers.append("Authorization", "Bearer " + environment.token);
    headers = headers.append("Content-Type", "application/json");
    const httpOptions = { headers };
    let body = JSON.stringify(input);
    return this._httpClient.post(environment.WebserviceUrl + "Accpartno", body, httpOptions);
  }

  GetPartNoList(input: string): Observable<any> {
    let headers = new HttpHeaders();
    headers = headers.append("Authorization", "Bearer " + environment.token);
    headers = headers.append("Content-Type", "application/json");
    const httpOptions = { headers };
    return this._httpClient.get(environment.WebserviceUrl + 'Accpartno/' + input, httpOptions);
  }

  DeletePartNo(acccode: string, othparty: string, PartNo: string): Observable<any> {
    let headers = new HttpHeaders();
    headers = headers.append("Authorization", "Bearer " + environment.token);
    headers = headers.append("Content-Type", "application/json");
    const httpOptions = { headers };
    return this._httpClient.delete(environment.WebserviceUrl + "Accpartno?acccode=" + acccode + "&othparty=" + othparty + "&PartNo=" + PartNo, httpOptions);
  }

  //End

  //User Master service

  AddUserDetail(input: UserMaster): Observable<any> {
    let headers = new HttpHeaders();
    headers = headers.append("Authorization", "Bearer " + environment.token);
    headers = headers.append("Content-Type", "application/json");
    const httpOptions = { headers };
    let body = JSON.stringify(input);
    return this._httpClient.post(environment.WebserviceUrl + "UserMaster", body, httpOptions);
  }

  UpdateUserDetail(input: UserMaster): Observable<any> {
    let headers = new HttpHeaders();
    headers = headers.append("Authorization", "Bearer " + environment.token);
    headers = headers.append("Content-Type", "application/json");
    const httpOptions = { headers };
    let body = JSON.stringify(input);
    return this._httpClient.put(environment.WebserviceUrl + "UserMaster", body, httpOptions);
  }


  GetUserDetail(input: number): Observable<any> {
    let headers = new HttpHeaders();
    headers = headers.append("Authorization", "Bearer " + environment.token);
    headers = headers.append("Content-Type", "application/json");
    const httpOptions = { headers };
    return this._httpClient.get(environment.WebserviceUrl + 'UserMaster?userId=' + input, httpOptions);
  }

  GetWebUserDetail(input: number): Observable<any> {
    let headers = new HttpHeaders();
    headers = headers.append("Authorization", "Bearer " + environment.token);
    headers = headers.append("Content-Type", "application/json");
    const httpOptions = { headers };
    return this._httpClient.get(environment.WebserviceUrl + 'Partylogin/PartyloginDetail?userid=' + input, httpOptions);
  }

  GetUserList(inType: number, input: number): Observable<any> {
    let headers = new HttpHeaders();
    headers = headers.append("Authorization", "Bearer " + environment.token);
    headers = headers.append("Content-Type", "application/json");
    const httpOptions = { headers };
    return this._httpClient.get(environment.WebserviceUrl + 'UserMaster?inType=' + inType + "&id=" + input, httpOptions);
  }

  DeleteUser(input: number, isActive: number, iLoginId: number): Observable<any> {
    let headers = new HttpHeaders();
    headers = headers.append("Authorization", "Bearer " + environment.token);
    headers = headers.append("Content-Type", "application/json");
    const httpOptions = { headers };
    return this._httpClient.delete(environment.WebserviceUrl + "UserMaster?id=" + input + "&isActive=" + isActive + "&iLoginId=" + iLoginId, httpOptions);
  }


  //Vendor Master
  GetVendorList(): Observable<any> {
    let headers = new HttpHeaders();
    headers = headers.append("Authorization", "Bearer " + environment.token);
    headers = headers.append("Content-Type", "application/json");
    const httpOptions = { headers };
    return this._httpClient.get(environment.WebserviceUrl + "VendorMaster", httpOptions);
  }

  AddNewVendor(input: VenderMaster): Observable<any> {
    let headers = new HttpHeaders();
    headers = headers.append("Authorization", "Bearer " + environment.token);
    headers = headers.append("Content-Type", "application/json");
    const httpOptions = { headers };
    let body = JSON.stringify(input);
    return this._httpClient.post(environment.WebserviceUrl + "VendorMaster", body, httpOptions);
  }

  GetVendorById(input: string): Observable<any> {
    let headers = new HttpHeaders();
    headers = headers.append("Authorization", "Bearer " + environment.token);
    headers = headers.append("Content-Type", "application/json");
    const httpOptions = { headers };
    return this._httpClient.get(environment.WebserviceUrl + 'VendorMaster/' + input.toString(), httpOptions);
  }

  UpdateVendor(input: VenderMaster): Observable<any> {
    let headers = new HttpHeaders();
    headers = headers.append("Authorization", "Bearer " + environment.token);
    headers = headers.append("Content-Type", "application/json");
    const httpOptions = { headers };
    let body = JSON.stringify(input);
    return this._httpClient.put(environment.WebserviceUrl + "VendorMaster", body, httpOptions);
  }

  DeleteVendor(vhno: string): Observable<any> {
    let headers = new HttpHeaders();
    headers = headers.append("Authorization", "Bearer " + environment.token);
    headers = headers.append("Content-Type", "application/json");
    const httpOptions = { headers };
    return this._httpClient.delete(environment.WebserviceUrl + "VendorMaster?id=" + vhno, httpOptions);
  }
  //End


  //Green tax Master
  GetGreenTaxList(): Observable<any> {
    let headers = new HttpHeaders();
    headers = headers.append("Authorization", "Bearer " + environment.token);
    headers = headers.append("Content-Type", "application/json");
    const httpOptions = { headers };
    return this._httpClient.get(environment.WebserviceUrl + "GreenTaxMaster", httpOptions);
  }

  AddNewGreenTax(input: GreentaxSlab): Observable<any> {
    let headers = new HttpHeaders();
    headers = headers.append("Authorization", "Bearer " + environment.token);
    headers = headers.append("Content-Type", "application/json");
    const httpOptions = { headers };
    let body = JSON.stringify(input);
    return this._httpClient.post(environment.WebserviceUrl + "GreenTaxMaster", body, httpOptions);
  }

  GetGreenTaxByToLoc(tloc: number): Observable<any> {
    let headers = new HttpHeaders();
    headers = headers.append("Authorization", "Bearer " + environment.token);
    headers = headers.append("Content-Type", "application/json");
    const httpOptions = { headers };
    return this._httpClient.get(environment.WebserviceUrl + 'GreenTaxMaster?tloc=' + tloc, httpOptions);
  }

  GetGreenTaxByLOC(floc: number, tloc: number): Observable<any> {
    let headers = new HttpHeaders();
    headers = headers.append("Authorization", "Bearer " + environment.token);
    headers = headers.append("Content-Type", "application/json");
    const httpOptions = { headers };
    return this._httpClient.get(environment.WebserviceUrl + "GreenTaxMaster?floc=" + floc + "&tloc=" + tloc, httpOptions);
  }

  UpdateGreenTax(input: GreentaxSlab): Observable<any> {
    let headers = new HttpHeaders();
    headers = headers.append("Authorization", "Bearer " + environment.token);
    headers = headers.append("Content-Type", "application/json");
    const httpOptions = { headers };
    let body = JSON.stringify(input);
    return this._httpClient.put(environment.WebserviceUrl + "GreenTaxMaster", body, httpOptions);
  }

  DeleteGreenTax(Id: number): Observable<any> {
    let headers = new HttpHeaders();
    headers = headers.append("Authorization", "Bearer " + environment.token);
    headers = headers.append("Content-Type", "application/json");
    const httpOptions = { headers };
    return this._httpClient.delete(environment.WebserviceUrl + "GreenTaxMaster?id=" + Id, httpOptions);
  }
  //End

  //=============================================================Role Master=================================================
  GetRoleList(): Observable<any> {
    let headers = new HttpHeaders();
    headers = headers.append("Authorization", "Bearer " + environment.token);
    headers = headers.append("Content-Type", "application/json");
    const httpOptions = { headers };
    return this._httpClient.get(environment.WebserviceUrl + "APIRoleMaster", httpOptions);
  }

  AddRoleDetail(input: RoleMaster): Observable<any> {
    let headers = new HttpHeaders();
    headers = headers.append("Authorization", "Bearer " + environment.token);
    headers = headers.append("Content-Type", "application/json");
    const httpOptions = { headers };
    let body = JSON.stringify(input);
    return this._httpClient.post(environment.WebserviceUrl + "APIRoleMaster", body, httpOptions);
  }

  UpdateRoleDetail(input: RoleMaster): Observable<any> {
    let headers = new HttpHeaders();
    headers = headers.append("Authorization", "Bearer " + environment.token);
    headers = headers.append("Content-Type", "application/json");
    const httpOptions = { headers };
    let body = JSON.stringify(input);
    return this._httpClient.put(environment.WebserviceUrl + "APIRoleMaster", body, httpOptions);
  }

  DeleteRole(code: string): Observable<any> {
    let headers = new HttpHeaders();
    headers = headers.append("Authorization", "Bearer " + environment.token);
    headers = headers.append("Content-Type", "application/json");
    const httpOptions = { headers };
    return this._httpClient.delete(environment.WebserviceUrl + "APIRoleMaster?code=" + code, httpOptions);
  }

  //==================================================Role Activities=========================================================
  GetRoleActivities(roleid: number): Observable<any> {
    let headers = new HttpHeaders();
    headers = headers.append("Authorization", "Bearer " + environment.token);
    headers = headers.append("Content-Type", "application/json");
    const httpOptions = { headers };
    // let body = JSON.stringify(input);
    return this._httpClient.get(environment.WebserviceUrl + "APIRoleActivities?id=" + roleid, httpOptions);
  }

  UpdateRoleActivities(input: any[]): Observable<any> {
    let headers = new HttpHeaders();
    headers = headers.append("Authorization", "Bearer " + environment.token);
    headers = headers.append("Content-Type", "application/json");
    const httpOptions = { headers };
    let body = JSON.stringify(input);
    return this._httpClient.post(environment.WebserviceUrl + "APIRoleActivities", body, httpOptions);
  }


  //-------------- Designation Role Master----------------------------------

  GetDesignationRoleList(): Observable<any> {
    let headers = new HttpHeaders();
    headers = headers.append("Authorization", "Bearer " + environment.token);
    headers = headers.append("Content-Type", "application/json");
    const httpOptions = { headers };
    return this._httpClient.get(environment.WebserviceUrl + "APIRoleDesignation", httpOptions);
  }

  AddDesignationRoleDetail(input: DesignationRoleMaster): Observable<any> {
    let headers = new HttpHeaders();
    headers = headers.append("Authorization", "Bearer " + environment.token);
    headers = headers.append("Content-Type", "application/json");
    const httpOptions = { headers };
    let body = JSON.stringify(input);
    return this._httpClient.post(environment.WebserviceUrl + "APIRoleDesignation", body, httpOptions);
  }

  UpdateDesignationRoleDetail(input: DesignationRoleMaster): Observable<any> {
    let headers = new HttpHeaders();
    headers = headers.append("Authorization", "Bearer " + environment.token);
    headers = headers.append("Content-Type", "application/json");
    const httpOptions = { headers };
    let body = JSON.stringify(input);
    return this._httpClient.put(environment.WebserviceUrl + "APIRoleDesignation", body, httpOptions);
  }

  DeleteDesignationRole(desgrole: number): Observable<any> {
    let headers = new HttpHeaders();
    headers = headers.append("Authorization", "Bearer " + environment.token);
    headers = headers.append("Content-Type", "application/json");
    const httpOptions = { headers };
    return this._httpClient.delete(environment.WebserviceUrl + "APIRoleDesignation?desgrole=" + desgrole, httpOptions);
  }

  //-------------- Paid ToPay charges----------------------------------

  GetPaidTopayChargeForGRBooking(floc: number, toloc: number): Observable<any> {
    let headers = new HttpHeaders();
    headers = headers.append("Authorization", "Bearer " + environment.token);
    headers = headers.append("Content-Type", "application/json");
    const httpOptions = { headers };
    return this._httpClient.get(environment.WebserviceUrl + "PaidToPayCharge?floc=" + floc + "&toloc=" + toloc, httpOptions);
  }

  GetPaidTopayChargeList(): Observable<any> {
    let headers = new HttpHeaders();
    headers = headers.append("Authorization", "Bearer " + environment.token);
    headers = headers.append("Content-Type", "application/json");
    const httpOptions = { headers };
    return this._httpClient.get(environment.WebserviceUrl + "PaidToPayCharge", httpOptions);
  }

  AddPaidTopayChargeDetail(input: TrpPaidTopaycharge): Observable<any> {
    let headers = new HttpHeaders();
    headers = headers.append("Authorization", "Bearer " + environment.token);
    headers = headers.append("Content-Type", "application/json");
    const httpOptions = { headers };
    let body = JSON.stringify(input);
    return this._httpClient.post(environment.WebserviceUrl + "PaidToPayCharge", body, httpOptions);
  }

  UpdatePaidTopayChargeDetail(input: TrpPaidTopaycharge): Observable<any> {
    let headers = new HttpHeaders();
    headers = headers.append("Authorization", "Bearer " + environment.token);
    headers = headers.append("Content-Type", "application/json");
    const httpOptions = { headers };
    let body = JSON.stringify(input);
    return this._httpClient.put(environment.WebserviceUrl + "PaidToPayCharge", body, httpOptions);
  }

  DeletePaidTopayCharge(recid: number): Observable<any> {
    let headers = new HttpHeaders();
    headers = headers.append("Authorization", "Bearer " + environment.token);
    headers = headers.append("Content-Type", "application/json");
    const httpOptions = { headers };
    return this._httpClient.delete(environment.WebserviceUrl + "PaidToPayCharge?recid=" + recid, httpOptions);
  }

  //-------------- GREENTAX FULLLOAD charges----------------------------------

  GetGreenTaxFullLoadChargeForGRBooking(floc: number, toloc: number, svehType: string): Observable<any> {
    let headers = new HttpHeaders();
    headers = headers.append("Authorization", "Bearer " + environment.token);
    headers = headers.append("Content-Type", "application/json");
    const httpOptions = { headers };
    return this._httpClient.get(environment.WebserviceUrl + "GreenTaxFullLoad?floc=" + floc + "&toloc=" + toloc + "&svehType=" + svehType, httpOptions);
  }

  GetGreenTaxFullLoadChargeList(): Observable<any> {
    let headers = new HttpHeaders();
    headers = headers.append("Authorization", "Bearer " + environment.token);
    headers = headers.append("Content-Type", "application/json");
    const httpOptions = { headers };
    return this._httpClient.get(environment.WebserviceUrl + "GreenTaxFullLoad", httpOptions);
  }

  AddGreenTaxFullLoadChargeDetail(input: Greentaxftl): Observable<any> {
    let headers = new HttpHeaders();
    headers = headers.append("Authorization", "Bearer " + environment.token);
    headers = headers.append("Content-Type", "application/json");
    const httpOptions = { headers };
    let body = JSON.stringify(input);
    return this._httpClient.post(environment.WebserviceUrl + "GreenTaxFullLoad", body, httpOptions);
  }

  UpdateGreenTaxFullLoadChargeDetail(input: Greentaxftl): Observable<any> {
    let headers = new HttpHeaders();
    headers = headers.append("Authorization", "Bearer " + environment.token);
    headers = headers.append("Content-Type", "application/json");
    const httpOptions = { headers };
    let body = JSON.stringify(input);
    return this._httpClient.put(environment.WebserviceUrl + "GreenTaxFullLoad", body, httpOptions);
  }

  DeleteGreenTaxFullLoadCharge(recid: number): Observable<any> {
    let headers = new HttpHeaders();
    headers = headers.append("Authorization", "Bearer " + environment.token);
    headers = headers.append("Content-Type", "application/json");
    const httpOptions = { headers };
    return this._httpClient.delete(environment.WebserviceUrl + "GreenTaxFullLoad?recid=" + recid, httpOptions);
  }

  //Company setup
  GetCompanysetupDetail(): Observable<any> {
    let headers = new HttpHeaders();
    headers = headers.append("Authorization", "Bearer " + environment.token);
    headers = headers.append("Content-Type", "application/json");
    const httpOptions = { headers };
    return this._httpClient.get(environment.WebserviceUrl + 'CompanySetup', httpOptions);
  }

  UpdateCompanysetupDetail(input: TRP_COMPANY_SETUP): Observable<any> {
    let headers = new HttpHeaders();
    headers = headers.append("Authorization", "Bearer " + environment.token);
    headers = headers.append("Content-Type", "application/json");
    const httpOptions = { headers };
    let body = JSON.stringify(input);
    return this._httpClient.post(environment.WebserviceUrl + "CompanySetup", body, httpOptions);
  }

  GETPartyEmailSetup(input: number): Observable<any> {
    let headers = new HttpHeaders();
    headers = headers.append("Authorization", "Bearer " + environment.token);
    headers = headers.append("Content-Type", "application/json");
    const httpOptions = { headers };
    return this._httpClient.get(environment.WebserviceUrl + "PartyEmailSetup?id=" + input, httpOptions);
  }

  UpdatePartyEmailSetup(input: EmailSetup): Observable<any> {
    let headers = new HttpHeaders();
    headers = headers.append("Authorization", "Bearer " + environment.token);
    headers = headers.append("Content-Type", "application/json");
    const httpOptions = { headers };
    let body = JSON.stringify(input);
    return this._httpClient.post(environment.WebserviceUrl + "PartyEmailSetup", body, httpOptions);
  }

  MergeParty(mainparty: string, mergeparty: string, userid: number): Observable<any> {
    let headers = new HttpHeaders();
    headers = headers.append("Authorization", "Bearer " + environment.token);
    headers = headers.append("Content-Type", "application/json");
    const httpOptions = { headers };
    return this._httpClient.get(environment.WebserviceUrl + "MergeParty?mainparty=" + mainparty + "&mergeparty=" + mergeparty + "&userid=" + userid, httpOptions);
  }

  DatabaseBackup(userid: number): Observable<any> {
    let headers = new HttpHeaders();
    headers = headers.append("Authorization", "Bearer " + environment.token);
    headers = headers.append("Content-Type", "application/json");
    const httpOptions = { headers };
    return this._httpClient.get(environment.WebserviceUrl + "dbBackupUtility?userid=" + userid, httpOptions);
  }

  //get event list
  GetEventList(): Observable<any> {
    let headers = new HttpHeaders();
    headers = headers.append("Authorization", "Bearer " + environment.token);
    headers = headers.append("Content-Type", "application/json");
    const httpOptions = { headers };
    return this._httpClient.get(environment.WebserviceUrl + "Events/GetEventList", httpOptions);
  }
  AddNewEvent(input: Events): Observable<any> {
    let headers = new HttpHeaders();
    headers = headers.append("Authorization", "Bearer " + environment.token);
    headers = headers.append("Content-Type", "application/json");
    const httpOptions = { headers };
    let body = JSON.stringify(input);
    return this._httpClient.post(environment.WebserviceUrl + "Events/SaveEvent", body, httpOptions);
  }

  UpdateEvent(input: Events): Observable<any> {
    let headers = new HttpHeaders();
    headers = headers.append("Authorization", "Bearer " + environment.token);
    headers = headers.append("Content-Type", "application/json");
    const httpOptions = { headers };
    let body = JSON.stringify(input);
    return this._httpClient.put(environment.WebserviceUrl + "Events/UpdateEvent", body, httpOptions);
  }

  GetEventDetail(id: number): Observable<any> {
    let headers = new HttpHeaders();
    headers = headers.append("Authorization", "Bearer " + environment.token);
    headers = headers.append("Content-Type", "application/json");
    const httpOptions = { headers };
    return this._httpClient.get(environment.WebserviceUrl + "Events/GetEventbyId?eventid=" + id, httpOptions);
  }

  GetTodayEvent(): Observable<any> {
    let headers = new HttpHeaders();
    headers = headers.append("Authorization", "Bearer " + environment.token);
    headers = headers.append("Content-Type", "application/json");
    const httpOptions = { headers };
    return this._httpClient.get(environment.WebserviceUrl + "Events/GetTodayEvent", httpOptions);
  }

  DeleteEvent(id: number, iUserId: number): Observable<any> {
    let headers = new HttpHeaders();
    headers = headers.append("Authorization", "Bearer " + environment.token);
    headers = headers.append("Content-Type", "application/json");
    const httpOptions = { headers };
    return this._httpClient.delete(environment.WebserviceUrl + "Events/DeleteEvent?id=" + id + "&iUserId=" + iUserId, httpOptions);
  }
}
